import { render, staticRenderFns } from "./DocumentTypeList.vue?vue&type=template&id=a2e5d26c&scoped=true"
import script from "./DocumentTypeList.vue?vue&type=script&lang=js"
export * from "./DocumentTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e5d26c",
  null
  
)

export default component.exports